import { Box, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import ItemExtraDto from "../../../models/ItemExtraDto";
import { useRestaurantData } from "../../../provider/RestaurantDataContext";
import AmountSelector from "./AmountSelector";
import { SelectedItemOptions } from "../../dialogs/itemOptionsDialog/ItemOptionsDialog";
import { currencyFormat } from "../../../utils/Utils";

interface ItemExtrasProps {
    itemExtras: ItemExtraDto[];
    displayOnly?: boolean;
    selectedOptions?: SelectedItemOptions;
}

export interface ItemExtraForm {
    amount: number;
}

export default function ItemExtras({ itemExtras, displayOnly = false, selectedOptions }: ItemExtrasProps) {
    const { t } = useTranslation();
    const { restaurantData: { currency: { detail } } } = useRestaurantData();

    return (
        <Box>
            {itemExtras.length > 0 &&
                <>
                    <Typography sx={{ fontWeight: 'bold' }} variant="h6">{t("itemExtras")}</Typography>
                    <Divider variant="fullWidth" sx={{ mb: '0.8rem', bgcolor: 'darkgrey' }} />
                    {
                        itemExtras.map((itemExtra) => {
                            const showPrice = itemExtra.price > 0;
                            return (
                                <Stack key={itemExtra.id} direction='row' justifyContent='space-between' alignItems="center">
                                    <Typography>{itemExtra.value.value}</Typography>
                                    {showPrice && <Typography>{currencyFormat(itemExtra.price)}{detail}</Typography>}
                                    {
                                        !displayOnly &&
                                        <AmountSelector
                                            sx={{ width: '30%' }}
                                            formName={`itemExtras.${itemExtra.id}.amount`}
                                            initValue={selectedOptions ? selectedOptions.itemExtras.filter(itemExtraSelected => itemExtraSelected.id === itemExtra.id)[0].amount : itemExtra.defaultAmount}
                                            maxValue={itemExtra.maxAmount} />
                                    }
                                </Stack>
                            );
                        })
                    }
                </>
            }
        </Box>
    )
}